module.exports = __webpack_public_path__ + "img/credit-card-down.fd827cd7.svg";